<template>
    <div :class="['login-wrap', {show: loginModal}]">
        <a v-if="isAuthenticated"
           :href="userInfo.href"
           class="project-controller-item pointer">
            {{userInfo.summary}}
        </a>

        <div v-if="isAuthenticated"
             @click="logout()"
             class="project-controller-item pointer">
            {{localizeList.logout}}
        </div>

        <modal v-else class="project-controller-item"
               v-model="loginModal"
               :btn-text="localizeList.logInUpper"
               :parent-focus="tabPosition === 7"
               :loading="isLoginLoading">
            <div :class="['login-form',{'warning': loginWarningShow}]">

                <login @toggleRegistration="toggleRegistration"
                       @resetForm="resetForm"
                       @loginWarning="loginWarning"
                       @login="login"
                       @logout="logout"
                       @changeTabPosition="tabPosition = $event"
                       @change-loading="(value) => isLoginLoading = value"
                       :loading="isLoginLoading"
                       :open-login-modal-from-basket="openLoginModalFromBasket"
                       :login-modal="loginModal"
                       :tab-position="tabPosition"
                       :is-autofocus="isAutofocus" />

                <registration @changeTouristRegistration="changeTouristRegistration"
                              @changeTabPosition="tabPosition = $event"
                              :show-registration="showRegistration"
                              :tab-position="tabPosition"
                              :login-modal="loginModal"
                              :submitting-agree-privacy-policy="getWindowSettings.submittingAgreePrivacyPolicy"
                              :open-login-modal-from-basket="openLoginModalFromBasket" />
            </div>
        </modal>
    </div>
</template>

<script>
    import {bus} from '../../../main.js'
    import Login from "./login";
    import Registration from "./registration";

    export default {
        name: "index",
        components: {Registration, Login},
        data() {
            return {
                userInfo: {
                    summary: "",
                    href: ""
                },
                touristRegistration: {},
                tabPosition: 0,
                maxTabPosition: 7,
                loginModal: false,
                openLoginModalFromBasket: false,
                loginWarningShow: false,
                isLoginLoading: false,
                isAuthenticated: false,
                showRegistration: false,
                isAutofocus: false,
                registrationUrl: null,
                passwordRecoveryUrl: null,

            }
        },
        created() {
            bus.$on('open-login-form', (data) => {
                this.loginModal = true;
                this.openLoginModalFromBasket = data.fromBasket
            });
            bus.$on('open-login', () => {
                this.loginModal = true;
            });

            bus.$on('logout', (cb) => {
                this.logout().then(() => cb(true))
            });
            bus.$on('close-login-form', (data) => {
                this.loginModal = false;
                this.openLoginModalFromBasket = data.fromBasket
            });
            window.addEventListener("keyup", this.keyup);
            window.addEventListener("keydown", this.keyDown);
        },
        mounted() {
            this.openRegistrationByUrl();

            this.isAuthenticated = this.$store.getters['tour/getIsAuthenticated'];

            this.getUserInfo();
        },
        computed: {
            getWindowSettings() {
              return window.settings;
            },
        },
        methods: {
            keyup(e) {
                if (this.loginModal && e.keyCode === 27) {
                    this.loginModal = false;
                }
            },
            keyDown(e) {
                if (!this.loginModal) return;

                if (e.keyCode === 9) {
                    e.preventDefault();
                    if (this.tabPosition >= this.maxTabPosition) {
                        this.tabPosition = 0;
                    } else {
                        if (this.showRegistration && this.tabPosition > 7) {
                            let isShow = false;

                            for (let i = this.tabPosition - 7; i < 100; i++) {
                                isShow = this.showRegistrationInput(this.touristRegistration.inputs[i]);

                                if (isShow) {
                                    this.tabPosition = i + 8;
                                    return
                                }
                            }
                            if (!isShow) {
                                let newTabPosition = this.touristRegistration.inputs.length + 8;
                                if (newTabPosition > this.tabPosition) {
                                    if (!this.showRegistrationInput(this.touristRegistration.text.short)) {
                                        newTabPosition++
                                    }
                                } else {
                                    newTabPosition = this.tabPosition + 1;
                                }
                                this.tabPosition = newTabPosition;
                            }
                        } else {
                            this.tabPosition++;
                        }
                    }
                }
            },
            changeTouristRegistration(obj) {
                this.touristRegistration = obj
            },
            openRegistrationByUrl() {
                const query = Object.assign({}, this.$route.query);
                const showRegistration = !!query.isPrivateUserRegistrationShow;

                if (!showRegistration) return;
                this.loginModal = true;
                this.showRegistration = true;

                delete query.isPrivateUserRegistrationShow;
                this.$router.replace({query});
            },
            showRegistrationInput(item) {
                if (!item) return false;

                const simpleRegistration = this.$store.getters['getSettings'].SimpleRegistration;
                const isShowCitizenAuthTourist = this.$store.getters['getSettings'].IsShowCitizenAuthTourist;
                return (item.short || !simpleRegistration && item.type !== "citizen" || (item.type === "citizen" && isShowCitizenAuthTourist))
            },
            login() {
                this.isAuthenticated = true;
                this.loginModal = false;
                this.getUserInfo()
            },
            logout() {
                this.loginModal = false;

                return new Promise(resolve => {
                    this.$store.dispatch("tour/A_LOGOUT")
                        .then(() => {
                            this.loginWarningShow = false;
                            this.isAuthenticated = false;
                            this.userInfo.summary = "";
                            this.userInfo.href = "";

                            bus.$emit('isAuthenticated', false);
                            resolve()
                        })
                })
            },
            loginWarning() {
                this.showRegistration = false;
                this.loginWarningShow = true;
            },
            resetForm() {
                this.showRegistration = false;

            },
            getUserInfo() {
                const cookie = document.cookie;
                if (!cookie.length) {
                    return
                }
                let user = cookie.split(";").find(x => x.includes("CommonApplicationAuthCookie_.masterweblight-auth"));
                if (!user) {
                    return
                }
                user = JSON.parse(user.split("=")[1]);
                this.userInfo.summary = decodeURIComponent(user.Summary);
                this.userInfo.href = `${this.$store.state.orderListUrl}`;
            },
            toggleRegistration() {
                this.showRegistration = !this.showRegistration;
                this.loginWarningShow = false;

                if (this.showRegistration) {
                    this.maxTabPosition += this.touristRegistration.inputs.length + 3;
                    setTimeout(() => {
                        this.tabPosition = 8;
                    }, 500);
                } else {
                    this.maxTabPosition = 7;
                    setTimeout(() => {
                        this.tabPosition = 0;
                    }, 500);
                }
            },
        },
        beforeDestroy() {
            window.removeEventListener('keydown', this.keyDown);
            window.removeEventListener("keyup", this.keyup);
        },
        watch: {
            loginModal(val) {
                this.isAutofocus = val;

                if (!val) {
                    this.tabPosition = 0;
                    this.openLoginModalFromBasket = false
                }
            },
        }
    }
</script>

<style scoped>
    .login-wrap {
        z-index: 2;
        display: flex;
    }
    .login-wrap.show {
        z-index: 11;
    }

    .project-controller .project-controller-item {
        padding: 5px 16px;
        position: relative;
        font-weight: 500;
        font-size: 13px;
        line-height: 15px;
        text-decoration: none;
        color: var(--white-color);
    }

    .project-controller .project-controller-item:not(:last-child):after {
        content: "";
        width: 1px;
        height: 60%;
        background-color: var(--white-color);
        position: absolute;
        top: 20%;
        right: 0;
    }

    .login-form {
        padding: 30px 40px 30px;
        overflow: hidden;
        transition: all .2s;
    }

    .login-form.warning {
        padding: 40px 50px 76px;
    }

</style>